export default {
  key: "claimSubmit",
  serviceKey: "hrdc",
  name: {
    singular: "Claim Submitted to HRDC",
    plural: "Claim Submitted to HRDC",
  },
  parents: [
    //
  ],
  add: {
    name: "Claim Submitted to HRDC",
  },
};
